/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { setRadioTabIndexToNegativeOneWhenAble } from '../../utils/accessibility.utils';

@Component({
  selector: 'app-selects-detail',
  templateUrl: './selects-detail.page.html',
  styleUrls: ['./selects-detail.page.scss']
})
export class SelectsDetailPage implements OnInit {
  question: any;
  answer: any;

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController
  ) {}

  onClickRadio(item) {
    this.popoverCtrl.dismiss(item);
  }

  ngOnInit() {
    this.question = this.navParams.data.question;
    this.answer = this.navParams.data.answer;
    if (this.answer == null) {
      const defaultVal = this.question.items.find((x) => x.default == true);
      let defaultElem: Element | null = null;
      if (defaultVal) {
        setTimeout(() => {
          defaultElem = document.querySelector('[default="true"]');
          defaultElem.scrollIntoView({ block: 'center' });
        }, 250);
      }
    }

    setRadioTabIndexToNegativeOneWhenAble('selects-detail-radio-list', 'selects-detail-radio-item');
  }
}
